import { render, staticRenderFns } from "./AcceptDenyBtnsColumn.vue?vue&type=template&id=32b76154&scoped=true&"
import script from "./AcceptDenyBtnsColumn.vue?vue&type=script&lang=js&"
export * from "./AcceptDenyBtnsColumn.vue?vue&type=script&lang=js&"
import style0 from "./AcceptDenyBtnsColumn.vue?vue&type=style&index=0&id=32b76154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b76154",
  null
  
)

export default component.exports